import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

const updateUserRoleCallable = httpsCallable(functions, 'updateUserRole');
const deleteUserAccountCallable = httpsCallable(functions, 'deleteUserAccount');
const updateUserEmploymentCallable = httpsCallable(
  functions,
  'updateUserEmployment'
);

export const updateUserRole = async (uid, newRole) => {
  const result = await updateUserRoleCallable({ uid, newRole });
  return result.data;
};

export const deleteUserAccount = async (uid) => {
  const result = await deleteUserAccountCallable({ uid });
  return result.data;
};

export const updateUserEmployment = async (uid, employment) => {
  const result = await updateUserEmploymentCallable({ uid, ...employment });
  return result.data;
};
